import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { icons } from "../../../../../../utils/icons"
import { ListProps } from "./types"
import TableList from "../tableList"
import { memo } from "react"


const ListDrop = ({ column, filterDropList, input, isLoading, row, totalPages, handleCreate }: ListProps) => {
    const { t } = useTranslation()
    const styles = useStyles()

    return (
        <>
            <Box sx={styles.flex} className="just wrap mb2 gp1">
                <Typography sx={styles.title} variant="blue_title">{t('dropList.titles.dropDownList')}</Typography>

                <Box sx={styles.flex} className="gp1">
                    <DinamicForm errors={filterDropList.errors} input={Object.values(input)} values={filterDropList.filterData} onChange={filterDropList.onChange} filter={false} />

                    {/* <Tooltip title={t('ToolTips.create')}>
                        <IconButton
                            className="add"
                            sx={styles.clean}
                            onClick={() => {
                                handleCreate()
                            }}
                        >
                            {icons('add')}
                        </IconButton>
                    </Tooltip> */}
                </Box>
            </Box>

            <TableList
                column={column}
                filterDropList={filterDropList}
                isLoading={isLoading}
                row={row}
                totalPages={totalPages}
            />

        </>
    )
}

export default memo(ListDrop)
